<template>
  <v-container grid-list-xs>
    <v-alert v-if="user"
             type="success"
             transition="fade-transition"
             v-model="alert"
             dismissible
    >You are logged in!</v-alert>
    <v-layout row wrap>
      <v-flex  v-for="author in authors" :key="author.id" xs12 md6 xl3 pa-2>
        <v-card
          :outlined="true">
          <v-card-title primary-title>
            {{ author.data.name }}
          </v-card-title>
          <v-card-subtitle>
            {{ author.data.count }}
          </v-card-subtitle>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data () {
      return {
        alert: false
      }
    },
    computed: {
      ...mapGetters({
        user: "user",
        authors: 'authors'
      })
    },
    methods: {

    }
  }
</script>
